<div class="container-fluid" dir="rtl">
  <!-- Loading Spinner -->
  <div *ngIf="isLoading" class="text-center my-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">در حال بارگذاری...</span>
    </div>
    <p class="mt-2">در حال بارگذاری اطلاعات فعالیت ماهانه...</p>
  </div>

  <!-- Error Message -->
  <div *ngIf="error && !isLoading" class="alert alert-danger text-center" role="alert">
    <i class="fas fa-exclamation-triangle me-2"></i>
    {{ error }}
    <button type="button" class="btn btn-outline-danger btn-sm ms-3" (click)="goBack()">
      بازگشت
    </button>
  </div>

  <!-- Main Content -->
  <div *ngIf="activityData && !isLoading" class="monthly-activity-detail">
    <!-- Header Section -->
    <div class="header-section card mb-4">
      <div class="card-header bg-primary text-white">
        <h4 class="mb-0">
          <i class="fas fa-chart-line me-2"></i>
          جزئیات فعالیت ماهانه
        </h4>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <p><strong>نماد:</strong> {{ activityData.symbol }} ({{ activityData.isin }})</p>
            <p><strong>عنوان شرکت:</strong> {{ activityData.title }}</p>
            <p><strong>شماره پیگیری:</strong> {{ formatNumber(activityData.traceNo) }}</p>
          </div>
          <div class="col-md-6">
            <p><strong>سال مالی:</strong> {{ formatNumber(activityData.fiscalYear) }}</p>
            <p><strong>ماه گزارش:</strong> {{ formatNumber(activityData.reportMonth) }}</p>
            <p><strong>پایان سال مالی:</strong> ماه {{ formatNumber(activityData.yearEndMonth) }}</p>
            <p><strong>فروش شرکت‌های زیرمجموعه:</strong>
              <span class="badge" [ngClass]="activityData.hasSubCompanySale ? 'bg-success' : 'bg-secondary'">
                {{ activityData.hasSubCompanySale ? 'دارد' : 'ندارد' }}
              </span>
            </p>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12">
            <p><strong>لینک گزارش:</strong>
              <a [href]="activityData.uri" target="_blank" class="btn btn-sm btn-outline-primary ms-2">
                <i class="fas fa-external-link-alt me-1"></i>
                مشاهده در سامانه کدال
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Production and Sales Section -->
    <div class="section-card card mb-4" *ngIf="activityData.productionAndSalesItems?.length">
      <div class="card-header bg-success text-white">
        <h5 class="mb-0">
          <i class="fas fa-industry me-2"></i>
          تولید و فروش
        </h5>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-striped table-hover">
            <thead class="table-dark">
              <tr>
                <th rowspan="2" class="text-center">نام محصول</th>
                <th rowspan="2" class="text-center">واحد</th>
                <th colspan="4" class="text-center">انباشته تا پایان دوره قبل</th>
                <th colspan="3" class="text-center">اصلاحات</th>
                <th colspan="4" class="text-center">انباشته اصلاحی تا پایان دوره قبل</th>
                <th colspan="4" class="text-center">ماه جاری</th>
                <th colspan="4" class="text-center">انباشته تا پایان دوره جاری</th>
                <th colspan="4" class="text-center">سال قبل</th>
                <th rowspan="2" class="text-center">نوع</th>
              </tr>
              <tr>
                <!-- Year to date -->
                <th class="text-center">تولید</th>
                <th class="text-center">فروش</th>
                <th class="text-center">نرخ فروش</th>
                <th class="text-center">مبلغ فروش</th>
                <!-- Corrections -->
                <th class="text-center">تولید</th>
                <th class="text-center">فروش</th>
                <th class="text-center">مبلغ فروش</th>
                <!-- Corrected year to date -->
                <th class="text-center">تولید</th>
                <th class="text-center">فروش</th>
                <th class="text-center">نرخ فروش</th>
                <th class="text-center">مبلغ فروش</th>
                <!-- Monthly -->
                <th class="text-center">تولید</th>
                <th class="text-center">فروش</th>
                <th class="text-center">نرخ فروش</th>
                <th class="text-center">مبلغ فروش</th>
                <!-- Cumulative to period -->
                <th class="text-center">تولید</th>
                <th class="text-center">فروش</th>
                <th class="text-center">نرخ فروش</th>
                <th class="text-center">مبلغ فروش</th>
                <!-- Previous year -->
                <th class="text-center">تولید</th>
                <th class="text-center">فروش</th>
                <th class="text-center">نرخ فروش</th>
                <th class="text-center">مبلغ فروش</th>
              </tr>
            </thead>
            <tbody>
              <!-- Data Rows -->
              <ng-container *ngFor="let item of getProductionSalesDataRows()">
                <tr class="data-row">
                  <td class="fw-bold">{{ item.productName }}</td>
                  <td class="text-center">{{ item.unit }}</td>
                  <td class="text-end">{{ formatNumber(item.yearToDateProductionQuantity) }}</td>
                  <td class="text-end">{{ formatNumber(item.yearToDateSalesQuantity) }}</td>
                  <td class="text-end">{{ formatNumber(item.yearToDateSalesRate) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.yearToDateSalesAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.yearToDateSalesAmount) }}</span></td>
                  <td class="text-end">{{ formatNumber(item.correctionProductionQuantity) }}</td>
                  <td class="text-end">{{ formatNumber(item.correctionSalesQuantity) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.correctionSalesAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.correctionSalesAmount) }}</span></td>
                  <td class="text-end">{{ formatNumber(item.correctedYearToDateProductionQuantity) }}</td>
                  <td class="text-end">{{ formatNumber(item.correctedYearToDateSalesQuantity) }}</td>
                  <td class="text-end">{{ formatNumber(item.correctedYearToDateSalesRate) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.correctedYearToDateSalesAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.correctedYearToDateSalesAmount) }}</span></td>
                  <td class="text-end">{{ formatNumber(item.monthlyProductionQuantity) }}</td>
                  <td class="text-end">{{ formatNumber(item.monthlySalesQuantity) }}</td>
                  <td class="text-end">{{ formatNumber(item.monthlySalesRate) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.monthlySalesAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.monthlySalesAmount) }}</span></td>
                  <td class="text-end">{{ formatNumber(item.cumulativeToPeriodProductionQuantity) }}</td>
                  <td class="text-end">{{ formatNumber(item.cumulativeToPeriodSalesQuantity) }}</td>
                  <td class="text-end">{{ formatNumber(item.cumulativeToPeriodSalesRate) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.cumulativeToPeriodSalesAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.cumulativeToPeriodSalesAmount) }}</span></td>
                  <td class="text-end">{{ formatNumber(item.previousYearProductionQuantity) }}</td>
                  <td class="text-end">{{ formatNumber(item.previousYearSalesQuantity) }}</td>
                  <td class="text-end">{{ formatNumber(item.previousYearSalesRate) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.previousYearSalesAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.previousYearSalesAmount) }}</span></td>
                  <td class="text-center">{{ item.type }}</td>
                </tr>
              </ng-container>

              <!-- Summary Rows -->
              <ng-container *ngFor="let item of getProductionSalesSummaryRows()">
                <tr [ngClass]="item.rowClass">
                  <td class="fw-bold">{{ item.productName }}</td>
                  <td class="text-center">{{ item.unit }}</td>
                  <td class="text-end fw-bold">{{ formatNumber(item.yearToDateProductionQuantity) }}</td>
                  <td class="text-end fw-bold">{{ formatNumber(item.yearToDateSalesQuantity) }}</td>
                  <td class="text-end fw-bold">{{ formatNumber(item.yearToDateSalesRate) }}</td>
                  <td class="text-end fw-bold"><span [ngbTooltip]="convertToToman(formatNumber(item.yearToDateSalesAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.yearToDateSalesAmount) }}</span></td>
                  <td class="text-end fw-bold">{{ formatNumber(item.correctionProductionQuantity) }}</td>
                  <td class="text-end fw-bold">{{ formatNumber(item.correctionSalesQuantity) }}</td>
                  <td class="text-end fw-bold"><span [ngbTooltip]="convertToToman(formatNumber(item.correctionSalesAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.correctionSalesAmount) }}</span></td>
                  <td class="text-end fw-bold">{{ formatNumber(item.correctedYearToDateProductionQuantity) }}</td>
                  <td class="text-end fw-bold">{{ formatNumber(item.correctedYearToDateSalesQuantity) }}</td>
                  <td class="text-end fw-bold">{{ formatNumber(item.correctedYearToDateSalesRate) }}</td>
                  <td class="text-end fw-bold"><span [ngbTooltip]="convertToToman(formatNumber(item.correctedYearToDateSalesAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.correctedYearToDateSalesAmount) }}</span></td>
                  <td class="text-end fw-bold">{{ formatNumber(item.monthlyProductionQuantity) }}</td>
                  <td class="text-end fw-bold">{{ formatNumber(item.monthlySalesQuantity) }}</td>
                  <td class="text-end fw-bold">{{ formatNumber(item.monthlySalesRate) }}</td>
                  <td class="text-end fw-bold"><span [ngbTooltip]="convertToToman(formatNumber(item.monthlySalesAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.monthlySalesAmount) }}</span></td>
                  <td class="text-end fw-bold">{{ formatNumber(item.cumulativeToPeriodProductionQuantity) }}</td>
                  <td class="text-end fw-bold">{{ formatNumber(item.cumulativeToPeriodSalesQuantity) }}</td>
                  <td class="text-end fw-bold">{{ formatNumber(item.cumulativeToPeriodSalesRate) }}</td>
                  <td class="text-end fw-bold"><span [ngbTooltip]="convertToToman(formatNumber(item.cumulativeToPeriodSalesAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.cumulativeToPeriodSalesAmount) }}</span></td>
                  <td class="text-end fw-bold">{{ formatNumber(item.previousYearProductionQuantity) }}</td>
                  <td class="text-end fw-bold">{{ formatNumber(item.previousYearSalesQuantity) }}</td>
                  <td class="text-end fw-bold">{{ formatNumber(item.previousYearSalesRate) }}</td>
                  <td class="text-end fw-bold"><span [ngbTooltip]="convertToToman(formatNumber(item.previousYearSalesAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.previousYearSalesAmount) }}</span></td>
                  <td class="text-center fw-bold">{{ item.type }}</td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Raw Materials Section -->
    <div class="section-card card mb-4" *ngIf="activityData.buyRawMaterialItems?.length">
      <div class="card-header bg-warning text-dark">
        <h5 class="mb-0">
          <i class="fas fa-cogs me-2"></i>
          خرید مواد اولیه
        </h5>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-striped table-hover">
            <thead class="table-dark">
              <tr>
                <th rowspan="2" class="text-center">نام ماده</th>
                <th rowspan="2" class="text-center">واحد</th>
                <th colspan="3" class="text-center">انباشته تا پایان دوره قبل</th>
                <th colspan="3" class="text-center">اصلاحات</th>
                <th colspan="3" class="text-center">انباشته اصلاحی تا پایان دوره قبل</th>
                <th colspan="3" class="text-center">ماه جاری</th>
                <th colspan="3" class="text-center">انباشته تا پایان دوره جاری</th>
                <th colspan="3" class="text-center">سال قبل</th>
              </tr>
              <tr>
                <th class="text-center">مقدار</th>
                <th class="text-center">نرخ</th>
                <th class="text-center">مبلغ</th>
                <th class="text-center">مقدار</th>
                <th class="text-center">نرخ</th>
                <th class="text-center">مبلغ</th>
                <th class="text-center">مقدار</th>
                <th class="text-center">نرخ</th>
                <th class="text-center">مبلغ</th>
                <th class="text-center">مقدار</th>
                <th class="text-center">نرخ</th>
                <th class="text-center">مبلغ</th>
                <th class="text-center">مقدار</th>
                <th class="text-center">نرخ</th>
                <th class="text-center">مبلغ</th>
                <th class="text-center">مقدار</th>
                <th class="text-center">نرخ</th>
                <th class="text-center">مبلغ</th>
              </tr>
            </thead>
            <tbody>
              <!-- Domestic Materials -->
              <tr class="table-secondary">
                <td colspan="19" class="fw-bold text-center">مواد اولیه داخلی</td>
              </tr>
              <ng-container *ngFor="let item of getDomesticRawMaterialDataRows()">
                <tr class="data-row">
                  <td>{{ item.materialName }}</td>
                  <td class="text-center">{{ item.unit }}</td>
                  <td class="text-end">{{ formatNumber(item.yearToDateQuantity) }}</td>
                  <td class="text-end">{{ formatNumber(item.yearToDateRate) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.yearToDateAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.yearToDateAmount) }}</span></td>
                  <td class="text-end">{{ formatNumber(item.correctionQuantity) }}</td>
                  <td class="text-end">{{ formatNumber(item.correctionRate) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.correctionAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.correctionAmount) }}</span></td>
                  <td class="text-end">{{ formatNumber(item.correctedYearToDateQuantity) }}</td>
                  <td class="text-end">{{ formatNumber(item.correctedYearToDateRate) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.correctedYearToDateAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.correctedYearToDateAmount) }}</span></td>
                  <td class="text-end">{{ formatNumber(item.monthlyPurchaseQuantity) }}</td>
                  <td class="text-end">{{ formatNumber(item.monthlyPurchaseRate) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.monthlyPurchaseAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.monthlyPurchaseAmount) }}</span></td>
                  <td class="text-end">{{ formatNumber(item.cumulativeToPeriodQuantity) }}</td>
                  <td class="text-end">{{ formatNumber(item.cumulativeToPeriodRate) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.cumulativeToPeriodAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.cumulativeToPeriodAmount) }}</span></td>
                  <td class="text-end">{{ formatNumber(item.previousYearQuantity) }}</td>
                  <td class="text-end">{{ formatNumber(item.previousYearRate) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.previousYearAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.previousYearAmount) }}</span></td>
                </tr>
              </ng-container>

              <!-- Imported Materials -->
              <tr class="table-secondary">
                <td colspan="19" class="fw-bold text-center">مواد اولیه وارداتی</td>
              </tr>
              <ng-container *ngFor="let item of getImportedRawMaterialDataRows()">
                <tr class="data-row">
                  <td>{{ item.materialName }}</td>
                  <td class="text-center">{{ item.unit }}</td>
                  <td class="text-end">{{ formatNumber(item.yearToDateQuantity) }}</td>
                  <td class="text-end">{{ formatNumber(item.yearToDateRate) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.yearToDateAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.yearToDateAmount) }}</span></td>
                  <td class="text-end">{{ formatNumber(item.correctionQuantity) }}</td>
                  <td class="text-end">{{ formatNumber(item.correctionRate) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.correctionAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.correctionAmount) }}</span></td>
                  <td class="text-end">{{ formatNumber(item.correctedYearToDateQuantity) }}</td>
                  <td class="text-end">{{ formatNumber(item.correctedYearToDateRate) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.correctedYearToDateAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.correctedYearToDateAmount) }}</span></td>
                  <td class="text-end">{{ formatNumber(item.monthlyPurchaseQuantity) }}</td>
                  <td class="text-end">{{ formatNumber(item.monthlyPurchaseRate) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.monthlyPurchaseAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.monthlyPurchaseAmount) }}</span></td>
                  <td class="text-end">{{ formatNumber(item.cumulativeToPeriodQuantity) }}</td>
                  <td class="text-end">{{ formatNumber(item.cumulativeToPeriodRate) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.cumulativeToPeriodAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.cumulativeToPeriodAmount) }}</span></td>
                  <td class="text-end">{{ formatNumber(item.previousYearQuantity) }}</td>
                  <td class="text-end">{{ formatNumber(item.previousYearRate) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.previousYearAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.previousYearAmount) }}</span></td>
                </tr>
              </ng-container>

              <!-- Summary Rows -->
              <ng-container *ngFor="let item of getRawMaterialSummaryRows()">
                <tr [ngClass]="item.rowClass">
                  <td class="fw-bold">{{ item.materialName }}</td>
                  <td class="text-center">{{ item.unit }}</td>
                  <td class="text-end fw-bold">{{ formatNumber(item.yearToDateQuantity) }}</td>
                  <td class="text-end fw-bold">{{ formatNumber(item.yearToDateRate) }}</td>
                  <td class="text-end fw-bold"><span [ngbTooltip]="convertToToman(formatNumber(item.yearToDateAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.yearToDateAmount) }}</span></td>
                  <td class="text-end fw-bold">{{ formatNumber(item.correctionQuantity) }}</td>
                  <td class="text-end fw-bold">{{ formatNumber(item.correctionRate) }}</td>
                  <td class="text-end fw-bold"><span [ngbTooltip]="convertToToman(formatNumber(item.correctionAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.correctionAmount) }}</span></td>
                  <td class="text-end fw-bold">{{ formatNumber(item.correctedYearToDateQuantity) }}</td>
                  <td class="text-end fw-bold">{{ formatNumber(item.correctedYearToDateRate) }}</td>
                  <td class="text-end fw-bold"><span [ngbTooltip]="convertToToman(formatNumber(item.correctedYearToDateAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.correctedYearToDateAmount) }}</span></td>
                  <td class="text-end fw-bold">{{ formatNumber(item.monthlyPurchaseQuantity) }}</td>
                  <td class="text-end fw-bold">{{ formatNumber(item.monthlyPurchaseRate) }}</td>
                  <td class="text-end fw-bold"><span [ngbTooltip]="convertToToman(formatNumber(item.monthlyPurchaseAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.monthlyPurchaseAmount) }}</span></td>
                  <td class="text-end fw-bold">{{ formatNumber(item.cumulativeToPeriodQuantity) }}</td>
                  <td class="text-end fw-bold">{{ formatNumber(item.cumulativeToPeriodRate) }}</td>
                  <td class="text-end fw-bold"><span [ngbTooltip]="convertToToman(formatNumber(item.cumulativeToPeriodAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.cumulativeToPeriodAmount) }}</span></td>
                  <td class="text-end fw-bold">{{ formatNumber(item.previousYearQuantity) }}</td>
                  <td class="text-end fw-bold">{{ formatNumber(item.previousYearRate) }}</td>
                  <td class="text-end fw-bold"><span [ngbTooltip]="convertToToman(formatNumber(item.previousYearAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.previousYearAmount) }}</span></td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Energy Consumption Section -->
    <div class="section-card card mb-4" *ngIf="activityData.energyItems?.length">
      <div class="card-header bg-info text-white">
        <h5 class="mb-0">
          <i class="fas fa-bolt me-2"></i>
          مصرف انرژی
        </h5>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-striped table-hover">
            <thead class="table-dark">
              <tr>
                <th class="text-center">صنعت</th>
                <th class="text-center">طبقه‌بندی</th>
                <th class="text-center">نوع انرژی</th>
                <th class="text-center">واحد</th>
                <th colspan="3" class="text-center">انباشته تا پایان دوره قبل</th>
                <th colspan="3" class="text-center">انباشته اصلاحی تا پایان دوره قبل</th>
                <th colspan="3" class="text-center">ماه جاری</th>
                <th colspan="3" class="text-center">انباشته تا پایان دوره جاری</th>
                <th colspan="3" class="text-center">سال قبل</th>
                <th class="text-center">پیش‌بینی سال جاری</th>
                <th class="text-center">توضیح تغییرات</th>
              </tr>
              <tr>
                <th colspan="4"></th>
                <th class="text-center">مصرف</th>
                <th class="text-center">نرخ</th>
                <th class="text-center">هزینه</th>
                <th class="text-center">مصرف</th>
                <th class="text-center">نرخ</th>
                <th class="text-center">هزینه</th>
                <th class="text-center">مصرف</th>
                <th class="text-center">نرخ</th>
                <th class="text-center">هزینه</th>
                <th class="text-center">مصرف</th>
                <th class="text-center">نرخ</th>
                <th class="text-center">هزینه</th>
                <th class="text-center">مصرف</th>
                <th class="text-center">نرخ</th>
                <th class="text-center">هزینه</th>
                <th class="text-center">مصرف</th>
                <th colspan="2"></th>
              </tr>
            </thead>
            <tbody>
              <!-- Data Rows -->
              <ng-container *ngFor="let item of getEnergyDataRows()">
                <tr class="data-row">
                  <td>{{ item.industry }}</td>
                  <td>{{ item.classification }}</td>
                  <td>{{ item.energyType }}</td>
                  <td class="text-center">{{ item.unit }}</td>
                  <td class="text-end">{{ formatNumber(item.yearToDateConsumption) }}</td>
                  <td class="text-end">{{ formatNumber(item.yearToDateRate) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.yearToDateCost))" tooltipClass="tooltip-class">{{ formatNumber(item.yearToDateCost) }}</span></td>
                  <td class="text-end">{{ formatNumber(item.correctedYearToDateConsumption) }}</td>
                  <td class="text-end">{{ formatNumber(item.correctedYearToDateRate) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.correctedYearToDateCost))" tooltipClass="tooltip-class">{{ formatNumber(item.correctedYearToDateCost) }}</span></td>
                  <td class="text-end">{{ formatNumber(item.monthlyConsumption) }}</td>
                  <td class="text-end">{{ formatNumber(item.monthlyRate) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.monthlyCost))" tooltipClass="tooltip-class">{{ formatNumber(item.monthlyCost) }}</span></td>
                  <td class="text-end">{{ formatNumber(item.cumulativeToPeriodConsumption) }}</td>
                  <td class="text-end">{{ formatNumber(item.cumulativeToPeriodRate) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.cumulativeToPeriodCost))" tooltipClass="tooltip-class">{{ formatNumber(item.cumulativeToPeriodCost) }}</span></td>
                  <td class="text-end">{{ formatNumber(item.previousYearConsumption) }}</td>
                  <td class="text-end">{{ formatNumber(item.previousYearRate) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.previousYearCost))" tooltipClass="tooltip-class">{{ formatNumber(item.previousYearCost) }}</span></td>
                  <td class="text-end">{{ formatNumber(item.forecastYearConsumption) }}</td>
                  <td>{{ item.consumptionChangeExplanation }}</td>
                </tr>
              </ng-container>

              <!-- Summary Rows -->
              <ng-container *ngFor="let item of getEnergySummaryRows()">
                <tr [ngClass]="item.rowClass">
                  <td class="fw-bold">{{ item.industry }}</td>
                  <td class="fw-bold">{{ item.classification }}</td>
                  <td class="fw-bold">{{ item.energyType }}</td>
                  <td class="text-center fw-bold">{{ item.unit }}</td>
                  <td class="text-end fw-bold">{{ formatNumber(item.yearToDateConsumption) }}</td>
                  <td class="text-end fw-bold">{{ formatNumber(item.yearToDateRate) }}</td>
                  <td class="text-end fw-bold"><span [ngbTooltip]="convertToToman(formatNumber(item.yearToDateCost))" tooltipClass="tooltip-class">{{ formatNumber(item.yearToDateCost) }}</span></td>
                  <td class="text-end fw-bold">{{ formatNumber(item.correctedYearToDateConsumption) }}</td>
                  <td class="text-end fw-bold">{{ formatNumber(item.correctedYearToDateRate) }}</td>
                  <td class="text-end fw-bold"><span [ngbTooltip]="convertToToman(formatNumber(item.correctedYearToDateCost))" tooltipClass="tooltip-class">{{ formatNumber(item.correctedYearToDateCost) }}</span></td>
                  <td class="text-end fw-bold">{{ formatNumber(item.monthlyConsumption) }}</td>
                  <td class="text-end fw-bold">{{ formatNumber(item.monthlyRate) }}</td>
                  <td class="text-end fw-bold"><span [ngbTooltip]="convertToToman(formatNumber(item.monthlyCost))" tooltipClass="tooltip-class">{{ formatNumber(item.monthlyCost) }}</span></td>
                  <td class="text-end fw-bold">{{ formatNumber(item.cumulativeToPeriodConsumption) }}</td>
                  <td class="text-end fw-bold">{{ formatNumber(item.cumulativeToPeriodRate) }}</td>
                  <td class="text-end fw-bold"><span [ngbTooltip]="convertToToman(formatNumber(item.cumulativeToPeriodCost))" tooltipClass="tooltip-class">{{ formatNumber(item.cumulativeToPeriodCost) }}</span></td>
                  <td class="text-end fw-bold">{{ formatNumber(item.previousYearConsumption) }}</td>
                  <td class="text-end fw-bold">{{ formatNumber(item.previousYearRate) }}</td>
                  <td class="text-end fw-bold"><span [ngbTooltip]="convertToToman(formatNumber(item.previousYearCost))" tooltipClass="tooltip-class">{{ formatNumber(item.previousYearCost) }}</span></td>
                  <td class="text-end fw-bold">{{ formatNumber(item.forecastYearConsumption) }}</td>
                  <td class="fw-bold">{{ item.consumptionChangeExplanation }}</td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Currency Exchange Section -->
    <div class="section-card card mb-4" *ngIf="activityData.currencyExchangeItems?.length">
      <div class="card-header bg-secondary text-white">
        <h5 class="mb-0">
          <i class="fas fa-exchange-alt me-2"></i>
          ارز و مبادلات ارزی
        </h5>
      </div>
      <div class="card-body">
        <!-- Currency Sources -->
        <h6 class="text-center mb-3">منابع ارزی</h6>
        <div class="table-responsive mb-4">
          <table class="table table-striped table-hover">
            <thead class="table-dark">
              <tr>
                <th rowspan="2" class="text-center">شرح</th>
                <th rowspan="2" class="text-center">ارز</th>
                <th colspan="3" class="text-center">انباشته تا پایان دوره قبل</th>
                <th colspan="3" class="text-center">انباشته اصلاحی تا پایان دوره قبل</th>
                <th colspan="3" class="text-center">ماه جاری</th>
                <th colspan="3" class="text-center">انباشته تا پایان دوره جاری</th>
                <th colspan="3" class="text-center">سال قبل</th>
                <th colspan="3" class="text-center">پیش‌بینی باقیمانده</th>
              </tr>
              <tr>
                <th colspan="2"></th>
                <th class="text-center">مبلغ ارزی</th>
                <th class="text-center">نرخ ارز</th>
                <th class="text-center">مبلغ ریالی</th>
                <th class="text-center">مبلغ ارزی</th>
                <th class="text-center">نرخ ارز</th>
                <th class="text-center">مبلغ ریالی</th>
                <th class="text-center">مبلغ ارزی</th>
                <th class="text-center">نرخ ارز</th>
                <th class="text-center">مبلغ ریالی</th>
                <th class="text-center">مبلغ ارزی</th>
                <th class="text-center">نرخ ارز</th>
                <th class="text-center">مبلغ ریالی</th>
                <th class="text-center">مبلغ ارزی</th>
                <th class="text-center">نرخ ارز</th>
                <th class="text-center">مبلغ ریالی</th>
                <th class="text-center">مبلغ ارزی</th>
                <th class="text-center">نرخ ارز</th>
                <th class="text-center">مبلغ ریالی</th>
              </tr>
            </thead>
            <tbody>
              <!-- Sources Data Rows -->
              <ng-container *ngFor="let item of getCurrencyExchangeSourcesData()">
                <tr class="data-row">
                  <td>{{ item.description }}</td>
                  <td class="text-center">{{ item.currency }}</td>
                  <td class="text-end">{{ formatNumber(item.yearToDateForeignAmount) }}</td>
                  <td class="text-end">{{ formatNumber(item.yearToDateExchangeRate) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.yearToDateRialAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.yearToDateRialAmount) }}</span></td>
                  <td class="text-end">{{ formatNumber(item.correctedYearToDateForeignAmount) }}</td>
                  <td class="text-end">{{ formatNumber(item.correctedYearToDateExchangeRate) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.correctedYearToDateRialAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.correctedYearToDateRialAmount) }}</span></td>
                  <td class="text-end">{{ formatNumber(item.monthlyForeignAmount) }}</td>
                  <td class="text-end">{{ formatNumber(item.monthlyExchangeRate) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.monthlyRialAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.monthlyRialAmount) }}</span></td>
                  <td class="text-end">{{ formatNumber(item.cumulativeToPeriodForeignAmount) }}</td>
                  <td class="text-end">{{ formatNumber(item.cumulativeToPeriodExchangeRate) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.cumulativeToPeriodRialAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.cumulativeToPeriodRialAmount) }}</span></td>
                  <td class="text-end">{{ formatNumber(item.previousYearForeignAmount) }}</td>
                  <td class="text-end">{{ formatNumber(item.previousYearExchangeRate) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.previousYearRialAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.previousYearRialAmount) }}</span></td>
                  <td class="text-end">{{ formatNumber(item.forecastRemainingForeignAmount) }}</td>
                  <td class="text-end">{{ formatNumber(item.forecastRemainingExchangeRate) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.forecastRemainingRialAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.forecastRemainingRialAmount) }}</span></td>
                </tr>
              </ng-container>

              <!-- Sources Summary -->
              <ng-container *ngFor="let item of getCurrencyExchangeSummaryRows()">
                <ng-container *ngIf="item.rowCode === 1">
                  <tr [ngClass]="item.rowClass">
                    <td class="fw-bold">{{ item.description }}</td>
                    <td class="text-center fw-bold">{{ item.currency }}</td>
                    <td class="text-end fw-bold">{{ formatNumber(item.yearToDateForeignAmount) }}</td>
                    <td class="text-end fw-bold">{{ formatNumber(item.yearToDateExchangeRate) }}</td>
                    <td class="text-end fw-bold">{{ formatNumber(item.yearToDateRialAmount) }}</td>
                    <td class="text-end fw-bold">{{ formatNumber(item.correctedYearToDateForeignAmount) }}</td>
                    <td class="text-end fw-bold">{{ formatNumber(item.correctedYearToDateExchangeRate) }}</td>
                    <td class="text-end fw-bold">{{ formatNumber(item.correctedYearToDateRialAmount) }}</td>
                    <td class="text-end fw-bold">{{ formatNumber(item.monthlyForeignAmount) }}</td>
                    <td class="text-end fw-bold">{{ formatNumber(item.monthlyExchangeRate) }}</td>
                    <td class="text-end fw-bold">{{ formatNumber(item.monthlyRialAmount) }}</td>
                    <td class="text-end fw-bold">{{ formatNumber(item.cumulativeToPeriodForeignAmount) }}</td>
                    <td class="text-end fw-bold">{{ formatNumber(item.cumulativeToPeriodExchangeRate) }}</td>
                    <td class="text-end fw-bold">{{ formatNumber(item.cumulativeToPeriodRialAmount) }}</td>
                    <td class="text-end fw-bold">{{ formatNumber(item.previousYearForeignAmount) }}</td>
                    <td class="text-end fw-bold">{{ formatNumber(item.previousYearExchangeRate) }}</td>
                    <td class="text-end fw-bold">{{ formatNumber(item.previousYearRialAmount) }}</td>
                    <td class="text-end fw-bold">{{ formatNumber(item.forecastRemainingForeignAmount) }}</td>
                    <td class="text-end fw-bold">{{ formatNumber(item.forecastRemainingExchangeRate) }}</td>
                    <td class="text-end fw-bold">{{ formatNumber(item.forecastRemainingRialAmount) }}</td>
                  </tr>
                </ng-container>
              </ng-container>
            </tbody>
          </table>
        </div>

        <!-- Currency Uses -->
        <h6 class="text-center mb-3">مصارف ارزی</h6>
        <div class="table-responsive">
          <table class="table table-striped table-hover">
            <thead class="table-dark">
              <tr>
                <th rowspan="2" class="text-center">شرح</th>
                <th rowspan="2" class="text-center">ارز</th>
                <th colspan="3" class="text-center">انباشته تا پایان دوره قبل</th>
                <th colspan="3" class="text-center">انباشته اصلاحی تا پایان دوره قبل</th>
                <th colspan="3" class="text-center">ماه جاری</th>
                <th colspan="3" class="text-center">انباشته تا پایان دوره جاری</th>
                <th colspan="3" class="text-center">سال قبل</th>
                <th colspan="3" class="text-center">پیش‌بینی باقیمانده</th>
              </tr>
              <tr>
                <th colspan="2"></th>
                <th class="text-center">مبلغ ارزی</th>
                <th class="text-center">نرخ ارز</th>
                <th class="text-center">مبلغ ریالی</th>
                <th class="text-center">مبلغ ارزی</th>
                <th class="text-center">نرخ ارز</th>
                <th class="text-center">مبلغ ریالی</th>
                <th class="text-center">مبلغ ارزی</th>
                <th class="text-center">نرخ ارز</th>
                <th class="text-center">مبلغ ریالی</th>
                <th class="text-center">مبلغ ارزی</th>
                <th class="text-center">نرخ ارز</th>
                <th class="text-center">مبلغ ریالی</th>
                <th class="text-center">مبلغ ارزی</th>
                <th class="text-center">نرخ ارز</th>
                <th class="text-center">مبلغ ریالی</th>
                <th class="text-center">مبلغ ارزی</th>
                <th class="text-center">نرخ ارز</th>
                <th class="text-center">مبلغ ریالی</th>
              </tr>
            </thead>
            <tbody>
              <!-- Uses Data Rows -->
              <ng-container *ngFor="let item of getCurrencyExchangeUsesData()">
                <tr class="data-row">
                  <td>{{ item.description }}</td>
                  <td class="text-center">{{ item.currency }}</td>
                  <td class="text-end">{{ formatNumber(item.yearToDateForeignAmount) }}</td>
                  <td class="text-end">{{ formatNumber(item.yearToDateExchangeRate) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.yearToDateRialAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.yearToDateRialAmount) }}</span></td>
                  <td class="text-end">{{ formatNumber(item.correctedYearToDateForeignAmount) }}</td>
                  <td class="text-end">{{ formatNumber(item.correctedYearToDateExchangeRate) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.correctedYearToDateRialAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.correctedYearToDateRialAmount) }}</span></td>
                  <td class="text-end">{{ formatNumber(item.monthlyForeignAmount) }}</td>
                  <td class="text-end">{{ formatNumber(item.monthlyExchangeRate) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.monthlyRialAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.monthlyRialAmount) }}</span></td>
                  <td class="text-end">{{ formatNumber(item.cumulativeToPeriodForeignAmount) }}</td>
                  <td class="text-end">{{ formatNumber(item.cumulativeToPeriodExchangeRate) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.cumulativeToPeriodRialAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.cumulativeToPeriodRialAmount) }}</span></td>
                  <td class="text-end">{{ formatNumber(item.previousYearForeignAmount) }}</td>
                  <td class="text-end">{{ formatNumber(item.previousYearExchangeRate) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.previousYearRialAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.previousYearRialAmount) }}</span></td>
                  <td class="text-end">{{ formatNumber(item.forecastRemainingForeignAmount) }}</td>
                  <td class="text-end">{{ formatNumber(item.forecastRemainingExchangeRate) }}</td>
                  <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.forecastRemainingRialAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.forecastRemainingRialAmount) }}</span></td>
                </tr>
              </ng-container>

              <!-- Uses Summary -->
              <ng-container *ngFor="let item of getCurrencyExchangeSummaryRows()">
                <ng-container *ngIf="item.rowCode === 2">
                  <tr [ngClass]="item.rowClass">
                    <td class="fw-bold">{{ item.description }}</td>
                    <td class="text-center fw-bold">{{ item.currency }}</td>
                    <td class="text-end fw-bold">{{ formatNumber(item.yearToDateForeignAmount) }}</td>
                    <td class="text-end fw-bold">{{ formatNumber(item.yearToDateExchangeRate) }}</td>
                    <td class="text-end fw-bold"><span [ngbTooltip]="convertToToman(formatNumber(item.yearToDateRialAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.yearToDateRialAmount) }}</span></td>
                    <td class="text-end fw-bold">{{ formatNumber(item.correctedYearToDateForeignAmount) }}</td>
                    <td class="text-end fw-bold">{{ formatNumber(item.correctedYearToDateExchangeRate) }}</td>
                    <td class="text-end fw-bold"><span [ngbTooltip]="convertToToman(formatNumber(item.correctedYearToDateRialAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.correctedYearToDateRialAmount) }}</span></td>
                    <td class="text-end fw-bold">{{ formatNumber(item.monthlyForeignAmount) }}</td>
                    <td class="text-end fw-bold">{{ formatNumber(item.monthlyExchangeRate) }}</td>
                    <td class="text-end fw-bold"><span [ngbTooltip]="convertToToman(formatNumber(item.monthlyRialAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.monthlyRialAmount) }}</span></td>
                    <td class="text-end fw-bold">{{ formatNumber(item.cumulativeToPeriodForeignAmount) }}</td>
                    <td class="text-end fw-bold">{{ formatNumber(item.cumulativeToPeriodExchangeRate) }}</td>
                    <td class="text-end fw-bold"><span [ngbTooltip]="convertToToman(formatNumber(item.cumulativeToPeriodRialAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.cumulativeToPeriodRialAmount) }}</span></td>
                    <td class="text-end fw-bold">{{ formatNumber(item.previousYearForeignAmount) }}</td>
                    <td class="text-end fw-bold">{{ formatNumber(item.previousYearExchangeRate) }}</td>
                    <td class="text-end fw-bold"><span [ngbTooltip]="convertToToman(formatNumber(item.previousYearRialAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.previousYearRialAmount) }}</span></td>
                    <td class="text-end fw-bold">{{ formatNumber(item.forecastRemainingForeignAmount) }}</td>
                    <td class="text-end fw-bold">{{ formatNumber(item.forecastRemainingExchangeRate) }}</td>
                    <td class="text-end fw-bold"><span [ngbTooltip]="convertToToman(formatNumber(item.forecastRemainingRialAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.forecastRemainingRialAmount) }}</span></td>
                  </tr>
                </ng-container>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Descriptions Section -->
    <div class="section-card card mb-4" *ngIf="activityData.descriptions?.length">
      <div class="card-header bg-light">
        <h5 class="mb-0">
          <i class="fas fa-file-alt me-2"></i>
          توضیحات
        </h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-12" *ngFor="let desc of activityData.descriptions">
            <div class="description-item p-3 mb-3 border rounded">
              <p class="mb-1">{{ desc.description }}</p>
              <small class="text-muted">نوع: {{ desc.rowType }} | کد ردیف: {{ desc.rowCode }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Navigation -->
    <div class="text-center mb-4">
      <button type="button" class="btn btn-secondary" (click)="goBack()">
        <i class="fas fa-arrow-right me-2"></i>
        بازگشت به لیست گزارش‌ها
      </button>
    </div>
  </div>
</div>